import {
  ArrowDownToDotIcon,
  BookOpen01Icon,
  CheckListIcon,
  Target01Icon,
  ViewIcon,
  FileCodeIcon,
  GitBranchIcon,
  Globe02Icon,
  Message01Icon,
  PlayIcon,
  Radar01Icon,
  Route01Icon,
  SentIcon,
  Target03Icon,
  FlashIcon,
} from '@terra/ui-icons';
import type {
  MentionEntity,
  ObjectContextKind,
} from '@terra/shared-dto-chat-types';

export const OBJECT_CONTEXT_KIND_ICONS: Record<
  ObjectContextKind,
  typeof Target03Icon
> = {
  Finding: ViewIcon,
  Signal: Target03Icon,
  EndPoint: FlashIcon,
  WebPage: Globe02Icon,
  Trace: Route01Icon,
  Skill: BookOpen01Icon,
  SourceCode: FileCodeIcon,
  Chat: Message01Icon,
};
export const MENTION_ENTITY_ICONS: Record<
  MentionEntity['entityType'],
  typeof Target03Icon | undefined
> = {
  Signal: Target03Icon,
  Finding: ViewIcon,
  EndPoint: FlashIcon,
  WebPage: Globe02Icon,
  NodeName: GitBranchIcon,
  TestingInstruction: CheckListIcon,
  HttpRequest: SentIcon,
  HttpResponse: ArrowDownToDotIcon,
  Trace: Route01Icon,
  Interact: PlayIcon,
  Skill: BookOpen01Icon,
  ObjectContext: Target01Icon,
  ExternalAsset: Radar01Icon,
};
export function readObjectContextKind(
  extraData?: MentionEntity['extraData'],
): ObjectContextKind | undefined {
  const objectContext = extraData?.objectContext;

  if (!objectContext || typeof objectContext !== 'object') {
    return undefined;
  }

  const kind = (objectContext as { objectKind?: unknown }).objectKind;

  if (typeof kind !== 'string') {
    return undefined;
  }

  if (!OBJECT_CONTEXT_KIND_ICONS[kind as ObjectContextKind]) {
    return undefined;
  }

  return kind as ObjectContextKind;
}

export function resolveMentionEntityIcon({
  entityType,
  objectKind,
}: {
  entityType: MentionEntity['entityType'];
  objectKind?: ObjectContextKind;
}): typeof Target03Icon | undefined {
  if (entityType === 'ObjectContext' && objectKind) {
    return OBJECT_CONTEXT_KIND_ICONS[objectKind] ?? Target01Icon;
  }

  return MENTION_ENTITY_ICONS[entityType];
}
